import * as React from "react";

import { Text } from "../..";
import { CustomTextJobQualification } from "../../../domain";

export const CustomTextQualificationView = (props: {
    qual: CustomTextJobQualification;
}) => {
    const { customText } = props.qual;
    return (
        <li>
            <Text variant="body1">{customText}</Text>
        </li>
    );
};
